module.exports = __webpack_public_path__ + "static/media/template-3.1223ea33.svg";